import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
    const location = useLocation();

    const isActive = (path) => location.pathname === path;

    return (
        <AppBar position="static" color="primary" elevation={0} sx={{ mb: 4 }}>
            <Toolbar>
                <Typography
                    variant="h6"
                    component={Link}
                    to="/"
                    sx={{
                        flexGrow: 1,
                        color: 'inherit',
                        textDecoration: 'none',
                        fontWeight: 700,
                        letterSpacing: '-0.5px'
                    }}
                >
                    Black Cat Rare Coins
                </Typography>
                <Box>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/about"
                        sx={{
                            fontWeight: isActive('/about') ? 'bold' : 'normal',
                            borderBottom: isActive('/about') ? '2px solid white' : 'none',
                            borderRadius: 0
                        }}
                    >
                        About
                    </Button>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/add-coin"
                        sx={{
                            fontWeight: isActive('/add-coin') ? 'bold' : 'normal',
                            borderBottom: isActive('/add-coin') ? '2px solid white' : 'none',
                            borderRadius: 0,
                            ml: 2
                        }}
                    >
                        Add Coin
                    </Button>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/sell-coin"
                        sx={{
                            fontWeight: isActive('/sell-coin') ? 'bold' : 'normal',
                            borderBottom: isActive('/sell-coin') ? '2px solid white' : 'none',
                            borderRadius: 0,
                            ml: 2
                        }}
                    >
                        Sell Coin
                    </Button>
                    <Button
                        color="inherit"
                        component={Link}
                        to="/edit-coin"
                        sx={{
                            fontWeight: isActive('/edit-coin') ? 'bold' : 'normal',
                            borderBottom: isActive('/edit-coin') ? '2px solid white' : 'none',
                            borderRadius: 0,
                            ml: 2
                        }}
                    >
                        Edit Coin
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
}
